
import React from 'react';
import { Button } from '../../ui/button';
import { KYPPageState, KYPPageActions } from '../../../lib/kyp-search/hooks/useKYPPageState';
import { PlayerProfileCard } from '../PlayerProfileCard';
import { EnhancedPlayerSimilaritySection } from '../../EnhancedPlayerSimilaritySection';


interface StaticDataPhaseProps {
  state: KYPPageState;
  actions: KYPPageActions;
}

export const StaticDataPhase: React.FC<StaticDataPhaseProps> = ({ state, actions }) => {
  const { 
    playerProfile, 
    playerStats, 
    playerInjuries, 
    playerTransfers, 
    playerAchievements,
    selectedPlayer,
    isLoading
  } = state;
  
  const { startKYPSearch, clearSearch } = actions;
  
  // Handle KYP search start
  const handleStartKYPSearch = () => {
    startKYPSearch();
  };
  
  return (
    <div className="space-y-6">
      {/* Player info section */}
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-xl font-semibold text-[#CECFD2]">
            {selectedPlayer?.name}
          </h2>
          <p className="text-gray-400">
            {playerProfile?.club_name} • {playerProfile?.position}
          </p>
        </div>
        
        <div className="flex gap-2">
          <Button
            onClick={clearSearch}
            variant="outline"
            className="border border-transparent hover:border-gray-700 bg-transparent hover:bg-[#26222E] text-[#CECFD2] transition-colors"
          >
            Clear
          </Button>
          
          <Button
            onClick={handleStartKYPSearch}
            className="bg-transparent hover:bg-[#3d37cc] text-[#CECFD2] hover:text-white transition-colors"
          >
            Start KYP Search
          </Button>
        </div>
      </div>
      

      
      {/* Player profile data */}
      {playerProfile && (
        <PlayerProfileCard 
          playerProfile={playerProfile}
          playerData={null}
          playerInjuries={playerInjuries}
          playerTransfers={playerTransfers}
          playerAchievements={playerAchievements}
          playerStats={playerStats}
          isLoading={isLoading}
        />
      )}
      
      {/* Player similarity section - using the enhanced component */}
      {playerProfile && !isLoading && selectedPlayer && (
        <EnhancedPlayerSimilaritySection 
          playerId={selectedPlayer.id}
          playerName={playerProfile.name}
        />
      )}
      
      {/* Start KYP search button (mobile/bottom) */}
      <div className="md:hidden mt-6">
        <Button
          onClick={handleStartKYPSearch}
          className="w-full bg-transparent hover:bg-[#3d37cc] text-[#CECFD2] hover:text-white transition-colors"
        >
          Start KYP Search
        </Button>
      </div>
    </div>
  );
};
